import { render, staticRenderFns } from "./dettaglioPrev.html?vue&type=template&id=616bbe9d&scoped=true&"
import script from "./DettaglioPrev.vue?vue&type=script&lang=js&"
export * from "./DettaglioPrev.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/styles/preventivo.css?vue&type=style&index=0&id=616bbe9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bbe9d",
  null
  
)

export default component.exports